import { FileArrowDown } from "@gravity-ui/icons";
import { Alert, Button, Flex, Icon } from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { clientIdAtom } from "./store/atoms/clientId";
import { exportExcelAction } from "./store/fetchers/exportExcel";
import { OrderListWithInfiniteScroll } from "./widgets/OrderListWithInfiniteScroll/OrderListWithInfiniteScroll";
import { PoizonOrderFilterWidget } from "./widgets/PoizonOrderFilterWidget/PoizonOrderFilterWidget";

export const PoizonOrderListWidget = () => {
  const exportExcel = useAction(exportExcelAction);

  const { clientId } = useParams();
  const setClientId = useAction(clientIdAtom);

  useEffect(() => {
    setClientId(clientId);
  }, [clientId, setClientId]);

  if (!clientId) {
    return <Alert title="Ошибка данных" message="Не указан id клиента" />;
  }
  return (
    <Flex direction="column">
      <PoizonOrderFilterWidget />
      <div style={{ margin: "10px 20px" }}>
        <Button onClick={exportExcel} view="flat-success">
          <Icon data={FileArrowDown} />
          Excel
        </Button>
      </div>
      <OrderListWithInfiniteScroll />
    </Flex>
  );
};
